import { CollectionTranslationsRepository } from '@lib/api/repository/collection-translations';
import { TranslationJobInput } from '@lib/types/collection-translations';

export default class CollectionTranslationsService {
  constructor(private repository: CollectionTranslationsRepository) {}
  start(collectionId: string) {
    return this.repository.start(collectionId);
  }

  find(input: TranslationJobInput, signal?: AbortSignal) {
    return this.repository.find(input, signal);
  }

  save(input: TranslationJobInput) {
    return this.repository.save(input);
  }
}
